import { useModalConfirmationContext } from 'src/app/shared/components/payments';
import type { PaymentType } from 'src/app/shared/utils/payments';

import { usePromoteFormData } from '../../../formContext/formData';
import { usePromoteFormState } from '../../../formContext/formState';

import { useTracking } from './hooks/useTracking';

export function useConfirmHighAmount(): (paymentType: PaymentType) => Promise<boolean> {
	const { trackAmountTooHighView, trackAmountTooHighConfirm, trackAmountTooHighCancel } = useTracking();

	const {
		promotionCountrySettings: { confirmationAmount },
		featureConfigs: { highAmountConfirmationModal },
	} = usePromoteFormData();
	const [{ amount }] = usePromoteFormState();

	const [, { displayModal }] = useModalConfirmationContext();

	return async function confirmHighAmount(paymentType): Promise<boolean> {
		if (
			!highAmountConfirmationModal ||
			!confirmationAmount ||
			amount < confirmationAmount.amount ||
			paymentType === 'paypal'
		) {
			return Promise.resolve(true);
		}

		trackAmountTooHighView();
		const result = await displayModal({ type: 'highAmount' });
		if (result) {
			trackAmountTooHighConfirm();
		} else {
			trackAmountTooHighCancel();
		}
		return result;
	};
}
